import { api } from '@api/api2';
import type { GetRelationAccountResidentsPayload } from './types';

export const getRelationAccountResidents = (
  payload: GetRelationAccountResidentsPayload
) => api.v4('get', 'personal-account/relation/resident/simple-list', payload);
